import {getAPIGatewayDataFromParent} from "../handler/ParentDataHandler";
import {publishCount, publishTime} from "../MetricUtility";
import {ERROR_METRIC_SUFFFIX} from "../constants";

const metricProcessName = "SCC_STOW_BUFFER";

export function getAPIGatewayPostRequest(request, resourcePath, processName = "stow") {
    return {
        resourcePath: resourcePath,
        httpMethod: "post",
        processName: processName,
        requestBody: request
    }
}

export async function getStowBufferTableData(request) {
    const metricName = "getStowAssociates";
    const args = getAPIGatewayPostRequest(request, "svs/associates/data");
    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return transformMachineList(response.data.associates);
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
}

function transformMachineList(machine) {
    return machine.map(machine => (
        {
            alias: machine.alias,
            name: machine.name,
            macAddress: machine.macAddress,
            location: machine.location,
            pph: machine.performance.pph === -1 ? '-' : machine.performance.pph,
            stowedBufferedPackages: machine.performance.stowBufferedCount,
            flyByRate: machine.performance.flyByRate,
            noReadRate: machine.performance.noReadCount,
            maxPph: machine.performance.maxPph,
            localMaxScanTime: machine.performance.localMaxScanTime
        })
    );
}



// WEBPACK FOOTER //
// ./src/resources/StowBufferResource.js